import { render, staticRenderFns } from "./VDemo.vue?vue&type=template&id=958003ec&"
import script from "./VDemo.vue?vue&type=script&lang=js&"
export * from "./VDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports